import * as React from 'react';
import { Modal } from 'antd';
import { ModalFormMode } from '../../admin-knowledge-base.type';
import { formLabels } from '../../admin-knowledge-base.constants';
import { memo } from 'react';
import { Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

interface ModalWrapperProps {
    mode: ModalFormMode;
    close: () => void;
    children: React.ReactNode;
    type: Types;
}

const ModalWrapper = memo(({ mode, close, children, type }: ModalWrapperProps) => {
    const title = `${mode === ModalFormMode.CREATE ? 'Добавить' : 'Редактировать'} ${
        formLabels[type]
    }`;

    return (
        <Modal
            title={title}
            open={mode !== ModalFormMode.CLOSE}
            footer={null}
            onCancel={close}
            width={type === Types.ARTICLE ? 1000 : 500}
            forceRender
        >
            {children}
        </Modal>
    );
});

export default ModalWrapper;
